var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Header'),_c('el-container',[(_vm.isLogin)?_c('div',[_c('TopNav')],1):_vm._e(),_c('el-main',[_c('router-view',{key:_vm.$route.fullPath})],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }